import type { RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { FeatureFlagsPage } from "./pages/FeatureFlagsPage";

function FeatureFlagsRoute() {
  const locale = useLocale();
  return <FeatureFlagsPage locale={locale} />;
}

export const featureFlagRoutes: RouteObject[] = [
  {
    path: "feature-flags",
    element: <FeatureFlagsRoute />,
  },
];
